import React, { FunctionComponent, useCallback } from 'react';
import { MongoEvent } from 'interfaces/events.interface';
import SmsReceivedTableContainer from './sms-received-table-container';
import { apiClient } from 'axios-client';
import { useCallsTableGloballyBlockedQuery } from 'generated/graphql';

type SmsReceivedTableRepositoryProps = {
  filters?: {
    page?: number;
    bilikZoneIds?: number[];
    proViewId?: number;
    piTelephone?: string;
    isSpam?: boolean;
  };
  itemPerPage: number;
  orderBy?: {
    column: string;
    direction: string;
  };
  onSort?: (column: string, direction: string) => void;
  onFilter?: (column: string, value: string) => void;
};

const SmsReceivedTableRepository: FunctionComponent<
  SmsReceivedTableRepositoryProps
> = ({ filters, itemPerPage, orderBy, onSort, onFilter }) => {
  const fetchSmsReceived = useCallback(
    async (skip: number, limit: number) => {
      return await apiClient
        .post<MongoEvent[]>(`/event/pro-sms`, {
          bilikZoneIds: filters?.bilikZoneIds,
          proViewId: filters?.proViewId,
          piTelephone: filters?.piTelephone,
          skip,
          limit,
          orderByDate: orderBy?.direction === 'ascending' ? 'ASC' : 'DESC',
          isSpam: filters?.isSpam,
          isStaffIncluded: true,
        })
        .then((response) => {
          return response.data;
        });
    },
    [
      orderBy?.direction,
      filters?.bilikZoneIds,
      filters?.page,
      filters?.piTelephone,
      filters?.proViewId,
      filters?.isSpam,
    ],
  );

  const { data } = useCallsTableGloballyBlockedQuery();

  return (
    <SmsReceivedTableContainer
      fetchSmsReceived={fetchSmsReceived}
      filters={filters}
      itemPerPage={itemPerPage}
      onSort={onSort}
      onFilter={onFilter}
      orderBy={orderBy}
      globallyBlocked={data?.globallyBlockedIdentity || []}
    />
  );
};

export default SmsReceivedTableRepository;
